// extracted by mini-css-extract-plugin
export default {"customerSearch":"CustomerSearch_customerSearch__M41kS"};